module.exports = __webpack_public_path__ + "media/images/icon__checkmark@3x-85dbae48f70fce4993d8b34942d4e052.png";